import React from 'react';
import { Box, keyframes } from '@mui/material';

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const RadarLayer: React.FC = () => {
  return (
    <Box
      sx={{
        position: 'absolute',
        top: '-15%',
        right: '-15%',
        width: '130vh',
        height: '130vh',
        pointerEvents: 'none',
        zIndex: 2,
        opacity: 0.2, // Boosted back for visibility
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          border: '3px solid rgba(0, 242, 150, 0.7)', // Much thicker
          borderRadius: '50%',
          animation: `${rotate} 60s linear infinite`,
          '&::before': {
            content: '""',
            position: 'absolute',
            top: '15%',
            left: '15%',
            right: '15%',
            bottom: '15%',
            border: '2px dashed rgba(0, 242, 150, 0.5)',
            borderRadius: '50%',
          },
          '&::after': {
            content: '""',
            position: 'absolute',
            top: '30%',
            left: '30%',
            right: '30%',
            bottom: '30%',
            border: '2px solid rgba(0, 242, 150, 0.4)',
            borderRadius: '50%',
          }
        }}
      />
      {/* Additional Ring */}
      <Box
        sx={{
          position: 'absolute',
          top: '45%',
          left: '45%',
          right: '45%',
          bottom: '45%',
          border: '2px dashed rgba(0, 242, 150, 0.4)',
          borderRadius: '50%',
        }}
      />
      {/* Scanning Line */}
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          width: '50%',
          height: '4px', // Thicker line
          background: 'linear-gradient(to right, transparent, rgba(0, 242, 150, 1))',
          boxShadow: '0 0 25px rgba(0, 242, 150, 0.8)', // Stronger, wider glow
          transformOrigin: 'left center',
          animation: `${rotate} 10s linear infinite`,
        }}
      />
    </Box>
  );
};

export default RadarLayer;
